<template>
  <div class="c-model-outer" :class="[extraClass, {'d-none': !showModel}]" style="position: relative; z-index: 9999;">
    <div class="c-model-wrap d-flex justify-content-center">
      <div class="c-model" :style="`max-width: ${width}px; margin-top: 30px;`">
        <a href="javascript:void(0)" v-on:click="closeModel" class="c-model-close"><i class="fa fa-times"></i></a>
        <div class="c-model-content">
          <slot></slot>    
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "base-model",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 1000,
    },
    extraClass: {
      type: String,
      default: "",
    }
  },
  watch: {
    open: function(value) {
      this.showModel = value;
    },
  },
  data() {
    return {
      showModel: this.open
    }
  },
  methods: {
    closeModel() {
      this.showModel = false;
      this.$emit('input', this.showModel);
    }
  },
  mounted() {

  }
};
</script>
<style scoped>
  .c-model-wrap {
      position: fixed;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      background: #00000059;
      z-index: 9999;
      overflow: auto;
  }
  .c-model {
    width: 100%;
    max-width: 1000px;
    position: relative;
  }
  .c-model-close {
    position: absolute;
    right: 22px;
    top: 22px;
    z-index: 9;
  }
</style>
